import React from 'react';
import { Header } from 'components/views';
import SolutionTemp from 'components/views/SolutionTemp';

export default function SolutionTempWrapper() {
  return (
    <>
      <Header />
      <SolutionTemp />
    </>
  )
}
